import {storeToRefs} from "pinia";

export function usePrice() {
    const settingsStore = useSettingsStore();
    const { locale } = useI18n();
    const { settings } = storeToRefs(settingsStore);

    const format = (amount: number, currencyOverride?: string) => {
        const currency = currencyOverride || settings.value?.currency || 'EUR';
        const numberLocale = locale.value;

        try {
            return new Intl.NumberFormat(numberLocale, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'symbol',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(amount);
        } catch {
            return amount.toFixed(2) + ' ' + currency;
        }
    };
    const oldPrice = (amount: number, discount:number) => amount / (1 - discount / 100);

    return { format,oldPrice };
}
